module.exports = __webpack_public_path__ + "img/Group 39952.c5649f25.svg";